import 'babel-polyfill';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import { AppContainer } from 'react-hot-loader';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from './store';

const store = configureStore(window.__INITIAL_STATE__);
// Remove the initial state object from window
delete window.__INITIAL_STATE__;

import Routes from './routes';

function renderApp(routesConfig) {
    ReactDOM.hydrate(
        <AppContainer>
            <Provider store={ store }>
                <BrowserRouter>
                    { renderRoutes(routesConfig) }
                </BrowserRouter>
            </Provider>
        </AppContainer>,
        document.getElementById('app')
    );
}


renderApp(Routes);


if (module.hot) {
    module.hot.accept('./routes.js', function() {
        const nextRoutes = require('./routes').default;
        renderApp(nextRoutes);
    })
}



// WEBPACK FOOTER //
// ./src/client/index.js